import { render, staticRenderFns } from "./RealEstateAddresses.vue?vue&type=template&id=c1afba90&scoped=true&"
import script from "./RealEstateAddresses.vue?vue&type=script&lang=js&"
export * from "./RealEstateAddresses.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateAddresses.vue?vue&type=style&index=0&id=c1afba90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1afba90",
  null
  
)

export default component.exports